<script lang="ts" setup>
import type {
	CuratedListSimilarRegionsProps,
	RegionCardClickedPayload,
	RegionClickedPayload,
	SimilarRegionClickedPayload
} from '.';
import type { RegionReport } from '~~/core/ports/repositories';

import { StandardSlider } from '../StandardSlider';
import RegionCard from './RegionCard.vue';

const props = withDefaults(defineProps<CuratedListSimilarRegionsProps>(), {
	containerClass: '',
	isLoading: false,
	title: 'Explore outros imóveis nos bairros que inspiram esta coleção'
});

const emit = defineEmits<{
	(e: 'region-clicked', payload: SimilarRegionClickedPayload): void;
	(e: 'region-card-clicked', payload: RegionCardClickedPayload): void;
}>();

const isRegionLoading = computed<boolean>(
	() => props.isLoading || !props.regionsReport?.length
);

function handleRegionClicked(payload: RegionClickedPayload, index: number) {
	emit('region-clicked', {
		...payload,
		card_position: index
	});
}

function handleRegionCardClicked(payload: RegionCardClickedPayload) {
	emit('region-card-clicked', payload);
}
</script>

<template>
	<section class="w-full bg-white">
		<component
			:is="StandardSlider<RegionReport>"
			:items="regionsReport"
			:container-class="containerClass"
			:section-name="sectionName"
			:title="title"
			:is-loading="isRegionLoading"
			carousel-item-size="quarter"
		>
			<template #items="{ item, index }">
				<RegionCard
					:city="item.city"
					:state="item.state"
					:region="item.region"
					:typologies="item.typologies || []"
					:property-count="item.propertyCount"
					:top-property-types="item.topPropertyTypes"
					@region-clicked="payload => handleRegionClicked(payload, index)"
					@region-card-clicked="payload => handleRegionCardClicked(payload)"
				/>
			</template>
		</component>
	</section>
</template>
